/* -------------------------------------------------------------------------------------------------
 * I18next
 * -----------------------------------------------------------------------------------------------*/

enum I18NEXT {
	routeIndex = 'route-_index',
}

/* -------------------------------------------------------------------------------------------------
 * Route loader
 * -----------------------------------------------------------------------------------------------*/

enum ROUTE_LOADER {
	root = 'root',
	current = 'routes/($lang)._index',
}

/* -----------------------------------------------------------------------------------------------*/

export { I18NEXT as INDEX_I18NEXT, ROUTE_LOADER as INDEX_ROUTE_LOADER }
